import React from 'react';
import { Button, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { postPurchaseBi } from '../postPurchaseBi';
import { WIX_HOME_URL } from '../helpers';
import styles from '../PostPurchaseStep.scss';

export function PostPurchaseAccessDenied() {
  const { t } = useTranslation();

  return (
    <div className={styles.postPurchaseAccessState}>
      <div className={styles.postPurchaseAccessStateContent}>
        <Heading as="h1" size="large">
          {t('post_purchase.access_denied.title')}
        </Heading>
        <Button
          as="a"
          href={WIX_HOME_URL}
          priority="primary"
          size="medium"
          onClick={() => postPurchaseBi.accessDeniedCta()}
        >
          {t('post_purchase.access_denied.cta')}
        </Button>
      </div>
    </div>
  );
}
